import React from 'react'
import { Transition } from 'react-transition-group'
import { Button } from 'core/components/button'
import { Field } from 'core/components/form/field'
import { TextInput } from 'core/components/form/text-input'
import { classNames } from 'core/helpers/misc'
import { ModalPortal } from './ModalPortal'

const closeModal = (action, setModal) =>
	setModal(prev => {
		const { alert, prompt, confirm } = prev
		const { onClose } = alert
		const { onSend } = prompt
		const { onAct } = confirm

		if (alert.opened && onClose) {
			onClose()
		} else if (prompt.opened && action !== 'close' && onSend) {
			onSend(prompt.value)
		} else if (confirm.opened && onAct) {
			onAct(action === 'submit')
		}

		return {
			alert: {
				message: '',
				opened: false,
			},
			confirm: {
				message: '',
				opened: false,
			},
			prompt: {
				message: '',
				opened: false,
				title: '',
				value: '',
			},
		}
	})

const renderAlert = (message, setModal) => (
	<div className="modal-content">
		<div className="modal-header">
			<h5 className="modal-title">Alerta</h5>

			<Button
				aria-label="close"
				className="close"
				data-dismiss="modal"
				onClick={() => closeModal('close', setModal)}
				type="button"
			/>
		</div>
		<div className="modal-body">
			<p>{message}</p>
		</div>
		<div className="modal-footer">
			<Button
				customClassName="btn-primary"
				onClick={() => closeModal('submit', setModal)}
				title="Ok"
			/>
		</div>
	</div>
)

const renderConfirm = (message, setModal) => (
	<div className="modal-content">
		<div className="modal-header">
			<h5 className="modal-title">Atenção</h5>

			<Button
				aria-label="close"
				className="close"
				data-dismiss="modal"
				onClick={() => closeModal('close', setModal)}
				type="button"
			/>
		</div>
		<div className="modal-body">
			<p>{message}</p>
		</div>
		<div className="modal-footer">
			<Button
				customClassName="btn-primary"
				icon="fas fa-check"
				onClick={() => closeModal('submit', setModal)}
				title="Sim"
			/>

			<Button
				customClassName="btn-danger"
				icon="fas fa-times"
				onClick={() => closeModal('cancel', setModal)}
				title="Não"
			/>
		</div>
	</div>
)

const renderPrompt = (prompt, setModal) => (
	<div className="modal-content">
		<div className="modal-header">
			<h5 className="modal-title">{prompt.title}</h5>

			<Button
				aria-label="close"
				className="close"
				data-dismiss="modal"
				onClick={() => closeModal('close', setModal)}
				type="button"
			/>
		</div>
		<div className="modal-body">
			<Field label={prompt.message}>
				<TextInput
					onChange={value =>
						setModal(prev => ({
							...prev,
							prompt: {
								...prev.prompt,
								value,
							},
						}))
					}
					placeholder="Digite..."
					type={prompt.type}
					value={prompt.value}
				/>
			</Field>
		</div>
		<div className="modal-footer">
			<Button
				customClassName="btn-secondary"
				icon="fas fa-arrow-left"
				onClick={() => closeModal('close', setModal)}
				title="Voltar"
				type="button"
			/>

			<Button
				customClassName="btn-primary"
				icon="fas fa-check"
				onClick={() => closeModal('submit', setModal)}
				title="Enviar"
			/>
		</div>
	</div>
)

export const Modal = React.memo(({ alert, prompt, confirm, setModal }) => {
	const show = alert.opened || prompt.opened || confirm.opened

	return (
		<ModalPortal>
			<Transition in={show} timeout={300}>
				{status => (
					<>
						<div
							aria-modal="true"
							className={classNames('modal fade', {
								show: status === 'entered',
							})}
							role="dialog"
							style={{
								display: status === 'exited' ? 'none' : 'block',
							}}
							tabIndex={-1}
						>
							<div className="modal-dialog modal-dialog-centered" role="document">
								{alert.opened && renderAlert(alert.message, setModal)}
								{confirm.opened && renderConfirm(confirm.message, setModal)}
								{prompt.opened && renderPrompt(prompt, setModal)}
							</div>
						</div>

						{status !== 'exited' && (
							<div
								className={classNames('modal-backdrop fade', {
									show: status === 'entered',
								})}
							/>
						)}
					</>
				)}
			</Transition>
		</ModalPortal>
	)
})
